<template>
  <div class="main-shifts-table-container">
    <div class="shifts-table-content">
      <div
        class="morning-slots"
        style="margin-right: 1rem"
        v-if="selectedTab === 'shiftsNextWeek'"
      >
        <div class="table-responsive">
          <table class="table table-bordered">
            <thead>
              <tr>
                <td style="color: red; font-weight: 600">User Overview</td>
                <th v-for="day in days" :key="day.id">{{ day.name }}
                  <span v-if="day.id < 7 && day.id !== 1" style="font-size: 10px">
                    {{tableHeadDates.length > 0 ? tableHeadDates[day.id -2] : getDateOfDay(day.id - 1)}}
                  </span> </th>
                <th style="color: green">V all</th>
                <th style="color: red">X all</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(user, idx) in currentWeekShiftsByUser" :key="idx" :style="user.every(s => s.approved === 1) ? 'background-color: #1ac51a52' : ''">
                <th scope="row" style="width: 160px;">
                  {{ user[0].user[0].full_name }}
                </th>
                <td
                  v-for="(u, i) in user"
                  :key="i"
                  :style="u.approved === 1 ? 'color: green' : 'color: orange'"
                  @click="
                    openApprovalDropdown(u.day_number, u.choice_id, i, idx)
                  "
                  style="cursor:pointer;"
                >
                  <div>
                    {{ u.choice_id === 4 ? "Any" : u.name }}
                  </div>
                  <span
                    v-if="
                      dropdown &&
                        dropdownNumber === u.day_number &&
                        dropdownShift === u.choice_id &&
                        uniqueIdx === i &&
                        overViewUserIndex === idx
                    "
                  >
                    <shifts-dropdown
                       :filter-dates="filterDates"
                       :user-strength="userStrength"
                      :shift-status="
                        u.approved === 1 ? 'shift-approved' : undefined
                      "
                      :shift="{ id: u.id, choice_id: u.choice_id, user_id: user[0].user[0].id }"
                      @closeDropdown="dropdown = false"
                    ></shifts-dropdown>
                  </span>
                </td>
                <td>x</td>
                <td>x</td>
                <td>
                  <i
                    class="fas fa-user-check"
                    v-if="user.every(s => s.choice_id !== 4)"
                    style="cursor: pointer"
                    @click="approveUser(user[0].user[0].id, false)"
                    :title="
                      'Approve all ' +
                        `${user[0].user[0].full_name}` +
                        ' shifts'
                    "
                  ></i>
                </td>
                <td>
                  <i
                    class="fas fa-user-times"
                    style="cursor: pointer"
                    @click="approveUser(user[0].user[0].id, true)"
                    :title="
                      'Un approve all ' +
                        `${user[0].user[0].full_name}` +
                        ' shifts'
                    "
                  ></i>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div
        class="morning-slots"
        style="margin: 0.3rem"
        v-if="selectedTab === 'shiftsThisWeek'"
      >
        <div class="table-responsive">
          <table class="table table-striped">
            <thead>
              <tr>
                <td style="color: red; font-weight: 600">User Overview</td>
                <th v-for="day in days" :key="day.id">{{ day.name }}</th>
                <th style="color: green">V all</th>
                <th style="color: red">X all</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(user, idx) in currentWeekShiftsByUser" :key="idx">
                <th scope="row" style="width: 160px;">
                  {{ user[0].user[0].full_name }}
                </th>
                <td
                  v-for="(u, i) in user"
                  :key="i"
                  :style="u.approved === 1 ? 'color: green' : 'color: orange'"
                  @click="
                    openApprovalDropdown(u.day_number, u.choice_id, i, idx)
                  "
                  style="cursor:pointer;"
                >
                  <div>
                    {{ u.choice_id === 4 ? "Any" : u.name }}
                  </div>
                  <span
                    v-if="
                      dropdown &&
                        dropdownNumber === u.day_number &&
                        dropdownShift === u.choice_id &&
                        uniqueIdx === i &&
                        overViewUserIndex === idx
                    "
                  >
                    <shifts-dropdown
                       :user-strength="userStrength"
                      :shift-status="
                        u.approved === 1 ? 'shift-approved' : undefined
                      "
                      :shift="{ id: u.id, choice_id: u.choice_id, user_id: user[0].user[0].id }"
                      @closeDropdown="dropdown = false"
                    ></shifts-dropdown>
                  </span>
                </td>
                <td>x</td>
                <td>x</td>
                <td>
                  <i
                    class="fas fa-user-check"
                    v-if="user.every(s => s.choice_id !== 4)"
                    style="cursor: pointer"
                    @click="approveUser(user[0].user[0].id, false)"
                    :title="
                      'Approve all ' +
                        `${user[0].user[0].full_name}` +
                        ' shifts'
                    "
                  ></i>
                </td>
                <td>
                  <i
                    class="fas fa-user-times"
                    style="cursor: pointer"
                    @click="approveUser(user[0].user[0].id, true)"
                    :title="
                      'Un approve all ' +
                        `${user[0].user[0].full_name}` +
                        ' shifts'
                    "
                  ></i>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import ShiftsDropdown from "../components/ShiftsDropdown";
import apiClientCreator from "@/helpers/api/request";
import {mapGetters, mapState} from "vuex";

export default {
  name: "ShiftsMainTable",
  props:{
    topLeftFetched: {
      type: Boolean,
      default: true
    },
    filterDates: {
      type: Object
    }
  },
  components: {
    ShiftsDropdown
  },
  computed: {
    ...mapState("user", ["auth"]),
    ...mapGetters("user", ["isLogged"]),
  },
  mounted() {
    //this.fetchShiftList();
    this.fetchShiftsByUser();
    this.fetchCurrentWeekShiftsByUser();
    this.fetchTotalSumForSlots();
    this.fetchThisWeekShifts([1, 2, 3, 8]);
    this.fetchUsersStrength()
  },
  watch: {

    filterDates: function(){
      if(this.filterDates.hasOwnProperty('date')){
        this.fetchCurrentWeekShiftsByUser(this.filterDates.date);
        let start = moment(this.filterDates.date.start).startOf('isoWeek').format('Y-MM-DD');
        let additions = [0, 1, 2, 3, 4];
        let dates = additions.map(d => moment(start).add(d, 'days').format("DD/MMM"))
        this.tableHeadDates = dates
      }
    },
    topLeftFetched: function(){
      this.fetchShiftList();
      this.fetchShiftsByUser();
      this.fetchTotalSumForSlots();
      this.fetchCurrentWeekShiftsByUser();
    },
    dropdown: function() {
      if (this.dropdown === false) {
        this.dropdownNumber = 0;
        this.dropdownShift = 0;
        this.uniqueIdx = null;
        this.overViewUserIndex = null;
        if(this.filterDates.hasOwnProperty('date')){
          this.fetchCurrentWeekShiftsByUser(this.filterDates.date);
        }else{
          this.fetchCurrentWeekShiftsByUser();
        }
        this.fetchShiftList();
        this.fetchShiftsByUser();
        this.fetchTotalSumForSlots();
        this.$emit("fetchNewShiftsData", true);
      }
    }
  },
  data() {
    return {
      tableHeadDates: [],
      days: [
        {
          id: 2,
          name: "Mon"
        },
        {
          id: 3,
          name: "Tue"
        },
        {
          id: 4,
          name: "Wed"
        },
        {
          id: 5,
          name: "Thu"
        },
        {
          id: 6,
          name: "Fri"
        },
        {
          id: 7,
          name: "Sat"
        },
        {
          id: 1,
          name: "Sun"
        }
      ],
      dropdown: false,
      dropdownNumber: 0,
      uniqueIdx: null,
      overViewUserIndex: null,
      dropdownShift: 0,
      shifts: [],
      shiftsByUser: [],
      currentWeekShiftsByUser: [],
      userModelShifts: [],
      morning: [],
      noon: [],
      evening: [],
      allShiftsApproved: false,
      sumMorning: null,
      sumNoon: null,
      sumEvening: null,
      selectedTab: "shiftsNextWeek",
      tabs: [
        {
          id: 1,
          name: "Shifts this week",
          alias: "shiftsThisWeek"
        },
        {
          id: 2,
          name: "Shifts next week",
          alias: "shiftsNextWeek"
        }
      ],
      userStrength: []
    };
  },
  methods: {
    getDateOfDay(amount = 1){
      return moment()
          .startOf('week')
          .add(amount, 'days')
          .format("DD/MMM")
    },
    fetchUsersStrength() {
          apiClientCreator('shifts/check_user_strength')
              .get("")
              .then(res => {
                this.userStrength = res.data
              })
    },
    approveUser(id, unApprove = false) {
      if (unApprove === false) {
        let approveUser = apiClientCreator(
          `shifts/approve_all_shifts_for_single_user/${id}`
        );
        let obj = {};
        if(this.filterDates.hasOwnProperty('date')){
          obj = {
            shifts_from: this.filterDates.date.start,
            shifts_to: this.filterDates.date.end
          }
        }
        approveUser.post("", obj).then(res => {
          this.fetchShiftsByUser();
          if(this.filterDates.hasOwnProperty('date')){
            this.fetchCurrentWeekShiftsByUser(this.filterDates.date);
          }else{
            this.fetchCurrentWeekShiftsByUser();
          }
          this.fetchShiftList();
        });
      }
      if (unApprove === true) {
        let approveUser = apiClientCreator(
          `shifts/approve_all_shifts_for_single_user/${id}`
        );
        approveUser
          .post("", {
            unApprove: unApprove
          })
          .then(res => {
            this.fetchShiftsByUser();
            if(this.filterDates.hasOwnProperty('date')){
              this.fetchCurrentWeekShiftsByUser(this.filterDates.date);
            }else{
              this.fetchCurrentWeekShiftsByUser();
            }
            this.fetchShiftList();
          });
      }
    },
    async fetchShiftList() {
      let getShiftList = apiClientCreator("shifts/list");
      let result = await getShiftList.get("");
      this.shifts = result.data;
    },
    weekRange(tab) {
      let r;
      if (tab === 1) {
        r = {
          start: moment()
            .startOf("week")
            .add("1", "days")
            .format("DD/MM"),
          end: moment()
            .endOf("week")
            .add("1", "days")
            .format("DD/MM")
        };
      }
      if (tab === 2) {
        r = {
          start: moment()
            .endOf("week")
            .add("2", "days")
            .format("DD/MM"),
          end: moment()
            .endOf("week")
            .add("8", "days")
            .format("DD/MM")
        };
      }
      return r;
    },

    setClickFromMenu(tab) {
      this.selectedTab = tab;
    },
    async fetchShiftsByUser() {
      let getShiftList = apiClientCreator("shifts/get_shifts_by_user");
      let result = await getShiftList.get("");
      this.shiftsByUser = result.data;
    },
    async fetchCurrentWeekShiftsByUser(dates = null) {
      let getShiftList = apiClientCreator(
        "shifts/get_current_week_shifts_by_user"
      );
      if(dates !== null){
        let d = {
          shifts_from: moment(dates.start).format('Y-MM-DD'),
          shifts_to: moment(dates.end).format('Y-MM-DD')
        }
        let result = await getShiftList.get("", {params: d});
        this.currentWeekShiftsByUser = result.data;
        this.$emit("fetchNewShiftsData", true);

      }else{
        let result = await getShiftList.get("");
        this.currentWeekShiftsByUser = result.data;
        //this.$emit("fetchNewShiftsData", true);
      }

      // if(this.currentWeekShiftsByUser.length > 0){
      //   if(this.currentWeekShiftsByUser[0].length === 5){
      //     let dates = this.currentWeekShiftsByUser[0]
      //     console.log(dates)
      //   }
      // }
    },

    async fetchTotalSumForSlots() {
      let sumShiftsForSlots = apiClientCreator("shifts/sum_shifts_for_slots");
      let result = await sumShiftsForSlots.get("");
      this.sumMorning = result.data.morning;
      this.sumNoon = result.data.noon;
      this.sumEvening = result.data.evening;
    },
    fetchThisWeekShifts(types) {
      let m = [];
      let n = [];
      let e = [];
      types.forEach(r => {
        let thisWeekShifts = apiClientCreator(
          `shifts/shifts_for_this_week/${r}`
        );
        thisWeekShifts.get("").then(({ data }) => {
          if (data.length > 0) {
            data.forEach(s => {
              if (r === 1) {
                m.push(s.user.full_name);
              }
              if (r === 2) {
                n.push(s.user.full_name);
              }
              if (r === 3) {
                e.push(s.user.full_name);
              }
            });
            if (r === 1) {
              this.morning = m;
            }
            if (r === 2) {
              this.noon = n;
            }
            if (r === 3) {
              this.evening = e;
            }
          } else {
          }
        });
      });
    },
    openApprovalDropdown(day, shift, idx = -1, extraIdx = -2) {
      this.overViewUserIndex = extraIdx;
      this.uniqueIdx = idx;
      this.dropdownNumber = day;
      this.dropdownShift = shift;
      this.dropdown = !this.dropdown;
    },
    getShift(shift, day) {
      if (shift.some(s => s.choice_day_number === day)) {
        if (shift.some(s => s.choice_day_number === day)) {
          let type = "shift-not-approved";
          shift.some(s => {
            if (s.choice_day_number === day && s.approved === 1) {
              type = "shift-approved";
            }
          });
          if (type === "shift-approved") {
            return "V";
          }
          if (type === "shift-not-approved") {
            return "X";
          }
        }
      } else {
        return "---";
      }
    },
    getShiftForDropdown(shift, day) {
      let r;
      if (shift.some(s => s.choice_day_number === day)) {
        shift.forEach(item => {
          if (item.choice_day_number === day) {
            r = item;
          }
        });
        return r;
      } else {
        return "---";
      }
    },
    getTotalShiftsForUser(slot, shiftNumber) {
      let sum = slot.map(s => s.hasOwnProperty("approved"));
      return sum.filter(Boolean).length;
    },
    async approveAllShifts() {
      let getShiftList = apiClientCreator("shifts/approve_all_shifts");
      let result = await getShiftList.get("");
      if (result.data[0] === true) {
        this.allShiftsApproved = true;
        await this.fetchShiftList();
      }
      if (result.data[0] === false) {
        this.allShiftsApproved = false;
      }
    },
    checkIfShiftIsApproved(shift, day) {
      if (shift.some(s => s.choice_day_number === day)) {
        let type = "shift-not-approved";
        shift.some(s => {
          if (s.choice_day_number === day && s.approved === 1) {
            type = "shift-approved";
          }
        });
        if (type === "shift-approved") {
          return type;
        }
      }
    },
    checkWhoApproved(shift, day) {
      let a = { full_name: "Not approved" };
      if (shift.some(s => s.choice_day_number === day)) {
        shift.some(s => {
          if (s.approved === 1) {
            a = s.approved_by;
          }
        });
        return a;
      }
      return a;
    }
  }
};
</script>

<style scoped>
.main-shifts-table-container {
  position: relative;
  width: 100%;
  min-height: 100%;
  margin: 1rem;
}
.main-table-tabs-wrapper {
}
.main-tabs {
  display: flex;
  list-style: none;
  justify-content: center;
  flex-direction: row;
}
.main-tabs > li {
  text-align: center;
  text-transform: uppercase;
  background-color: #b6c4de;
}
li.active {
  background-color: #c12fff !important;
  color: #fff;
}

span.tabName {
  padding-right: 10px;
}
th,
td {
  font-size: 13px;
  text-align: center;
}
th {
  font-weight: 600;
}
.morning-slots {
  margin-top: 2rem;
  width: 100%;
  height: 280px;
  overflow-y: scroll;
}
.morning-slots::-webkit-scrollbar {
  width: 9px;
  height: 9px;
}
.morning-slots::-webkit-scrollbar-thumb {
  background: linear-gradient(13deg, #C7CEFF 14%,#c7ceff 64%);
  border-radius: 10px;
}
.morning-slots::-webkit-scrollbar-track{
  background: #ffffff;
  border-radius: 10px;
  box-shadow: inset 7px 10px 12px #f0f0f0;
}
</style>
